function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import { oneOf, number, node } from 'prop-types';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import Grid from '@bbc/psammead-grid';
import { mostReadListGridProps } from '../utilities/gridProps';
var OneColumnGrid = /*#__PURE__*/styled(Grid).attrs({
  role: 'list'
}).withConfig({
  displayName: "OneColumnGrid",
  componentId: "sc-1ofyujo-0"
})(["list-style-type:none;margin:0;padding:0;grid-auto-flow:column;grid-template-rows:repeat(", ",auto);"], function (props) {
  return props.numberOfItems;
});
var TwoColumnGrid = /*#__PURE__*/styled(OneColumnGrid).withConfig({
  displayName: "TwoColumnGrid",
  componentId: "sc-1ofyujo-1"
})(["@media (min-width:", "){grid-template-rows:repeat( ", ",auto );}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, function (props) {
  return Math.ceil(props.numberOfItems / 2);
});
var MultiColumnGrid = /*#__PURE__*/styled(TwoColumnGrid).withConfig({
  displayName: "MultiColumnGrid",
  componentId: "sc-1ofyujo-2"
})(["@media (min-width:", "){grid-auto-flow:row;}"], GEL_GROUP_5_SCREEN_WIDTH_MIN);

var getColumnLayout = function getColumnLayout(columnLayout) {
  return {
    oneColumn: OneColumnGrid,
    twoColumn: TwoColumnGrid,
    multiColumn: MultiColumnGrid
  }[columnLayout];
};

var MostReadList = function MostReadList(_ref) {
  var numberOfItems = _ref.numberOfItems,
      dir = _ref.dir,
      columnLayout = _ref.columnLayout,
      children = _ref.children;
  var MostReadListGrid = getColumnLayout(columnLayout);
  return /*#__PURE__*/React.createElement(MostReadListGrid, _extends({}, mostReadListGridProps(columnLayout), {
    dir: dir,
    numberOfItems: numberOfItems,
    forwardedAs: "ol"
  }), children);
};

MostReadList.propTypes = {
  children: node.isRequired,
  dir: oneOf(['rtl', 'ltr']),
  columnLayout: oneOf(['oneColumn', 'twoColumn', 'multiColumn']),
  numberOfItems: number.isRequired
};
MostReadList.defaultProps = {
  dir: 'ltr',
  columnLayout: 'multiColumn'
};
export default MostReadList;